import { render } from "./CodeBlock.vue?vue&type=template&id=0cdcfc82"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/code/CodeBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cdcfc82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cdcfc82', __exports__)) {
    api.reload('0cdcfc82', __exports__)
  }
  
  module.hot.accept("./CodeBlock.vue?vue&type=template&id=0cdcfc82", () => {
    api.rerender('0cdcfc82', render)
  })

}


export default __exports__